import PropTypes from 'prop-types'
import React from 'react'

import Menu from 'components/menu/Menu'
import styles from './dashboard-container.scss'

class DashboardContainer extends React.Component {
  render() {
    const { children, isLogin = false } = this.props

    return (
      <div className={isLogin ? styles['container-login'] : styles['container']}>
        <div className={styles['grid']}>
          <Menu />
          <div className={styles['dashboard-section']}>{children}</div>
        </div>
      </div>
    )
  }
}

DashboardContainer.propTypes = {
  children: PropTypes.any,
  isLogin: PropTypes.bool
}

export default DashboardContainer



// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.jsx